import { render, staticRenderFns } from "./homeInsurance.vue?vue&type=template&id=7bf4e002&"
import script from "./homeInsurance.vue?vue&type=script&lang=js&"
export * from "./homeInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports